import { ReviewCard } from '@/components/cards/review-card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@/components/ui/table'
import type { Request } from '@/types/requests/request'
import { useResultTable } from './hooks/use-result-table'

interface ResultTableProps {
  request?: Request
}

export const ResultTable = ({ request }: ResultTableProps) => {
  const {
    states: { previousCourseInfo, courses }
  } = useResultTable(request)

  return (
    <ReviewCard title="Dados do Histórico" headerCard={true}>
      <ul className="grid grid-cols-2 p-6 gap-4">
        {previousCourseInfo.map(({ value, label }) => (
          <li key={label}>
            <span className="text-foreground/40 pe-1">{label}</span>
            {value}
          </li>
        ))}
      </ul>
      <div className="border-b border-muted-foreground/20 w-full"></div>
      <Table className="p-4 table-fixed">
        <TableHeader>
          <TableRow>
            <TableHead className="italic text-foreground/40">
              Disciplinas Aprovadas:
            </TableHead>
            <TableHead className="w-32" />
          </TableRow>
        </TableHeader>
        <TableBody>
          {courses?.map((discipline) => (
            <TableRow key={discipline.name}>
              <TableCell className="border-b border-muted-foreground/20 max-w-full truncate">
                {discipline.name}
              </TableCell>
              <TableCell className="text-center border-b border-muted-foreground/20">
                {discipline.workload} horas
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </ReviewCard>
  )
}
